export const IFRAMED = !!(window.parent && window.parent.location !== window.location);

export function domain() {
  return window.CREDERE._INTERNAL?.domain;
}

export function endpoint() {
  return window.CREDERE._INTERNAL?.endpoint;
}

/*
 * COMO O HOST TROCA DE TELA, e é ele quem declara em `CREDERE._INTERNAL.navigation` porque
 * daqui não há como descobrir: as duas formas rodam no mesmo `window`.
 *
 * `document` é o host que carrega OUTRA PÁGINA (o `web`, com `window.location`): o documento
 * em que este app roda vai embora inteiro, por conta do navegador.
 *
 * `client` é o host que troca a view NO MESMO documento (a `pwa`, com `$router.push`), e
 * também a página do lojista, que não é nossa. É o DEFAULT - host que não declara nada
 * continua com o comportamento de sempre.
 *
 * O NOME DIZ O EFEITO e não o modo, porque é a única coisa que este app tira dali: host de
 * documento é host SEM a cortina do `home-blank` (`routers/blank.js`).
 */
export function blankless() {
  return window.CREDERE._INTERNAL?.navigation === 'document';
}

export default function parent() {
  if (endpoint()) {
    return window;
  }

  return IFRAMED ? window.parent : window;
}
